"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.duplicateList = void 0;
const DUPLICATE_LIST_PATH = (shoppingListId) => `/v1/bff/appro/shopping-lists/${shoppingListId}/duplicate`;
const duplicateList = (client) => async ({ shoppingListId, listTitle, ...body }) => {
    const response = await client.post(DUPLICATE_LIST_PATH(shoppingListId), body, {
        params: { listTitle }
    });
    return response.data;
};
exports.duplicateList = duplicateList;
